import Record from "./base"

export default class Analytic extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
